import actions from './actions';

const initialState = {
  overviewsettingData: [],
  overviewsettingLoading: false,
  overviewsettingError: null,

  productconfigData: [],
  productconfigLoading: false,
  productconfigError: null,

  otherexpenseData: [],
  otherexpenseLoading: false,
  otherexpenseError: null,

  cashbackData: [],
  cashbackLoading: false,
  cashbackError: null,

  exceptionruleData: [],
  exceptionruleLoading: false,
  exceptionruleError: null,

  configreconcileData: [],
  configreconcileLoading: false,
  configreconcileError: null,

  channel: [],
  getchannelsLoading: false,
  getchannelsError: null,

  userinfoData: [],
  userinfoLoading: false,
  userinfoError: null,

  adduserData: [],
  adduserLoading: false,
  adduserError: null,

  subUsersData: [],
  subUsersLoading: false,
  subUsersError: null,

  deleteUserLoading: false,
  deleteUserError: null,

  exportLoading: false,

  uploadLoading: false,
  uploadError: null,
  uploadSuccess: false,
};

const {
  OVERVIEW_SETTING_BEGIN,
  OVERVIEW_SETTING_SUCCESS,
  OVERVIEW_SETTING_ERR,

  PRODUCT_CONFIG_BEGIN,
  PRODUCT_CONFIG_SUCCESS,
  PRODUCT_CONFIG_ERR,

  OTHER_EXPENSES_BEGIN,
  OTHER_EXPENSES_SUCCESS,
  OTHER_EXPENSES_ERR,

  CASHBACK_BEGIN,
  CASHBACK_SUCCESS,
  CASHBACK_ERR,

  EXCEPTION_RULES_BEGIN,
  EXCEPTION_RULES_SUCCESS,
  EXCEPTION_RULES_ERR,

  CONFIG_RECONCILE_BEGIN,
  CONFIG_RECONCILE_SUCCESS,
  CONFIG_RECONCILE_ERR,

  GET_CHANNELS_BEGIN,
  GET_CHANNELS_SUCCESS,
  GET_CHANNELS_ERR,

  USER_INFO_BEGIN,
  USER_INFO_SUCCESS,
  USER_INFO_ERR,

  ADD_USER_BEGIN,
  ADD_USER_SUCCESS,
  ADD_USER_ERR,

  GET_SUB_USERS_BEGIN,
  GET_SUB_USERS_SUCCESS,
  GET_SUB_USERS_ERR,

  DELETE_SUB_USER_BEGIN,
  DELETE_SUB_USER_SUCCESS,
  DELETE_SUB_USER_ERR,

  UPLOAD_PRODUCT_CONFIGURATION_BEGIN,
  UPLOAD_PRODUCT_CONFIGURATION_SUCCESS,
  UPLOAD_PRODUCT_CONFIGURATION_ERR,
} = actions;

const settingsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case OVERVIEW_SETTING_BEGIN:
      return {
        ...state,
        overviewsettingLoading: true,
      };

    case OVERVIEW_SETTING_SUCCESS:
      return {
        ...state,
        overviewsettingData: data,
        overviewsettingLoading: false,
      };

    case OVERVIEW_SETTING_ERR:
      return {
        ...state,
        overviewsettingError: err,
        overviewsettingLoading: false,
      };

    case PRODUCT_CONFIG_BEGIN:
      return {
        ...state,
        productconfigLoading: true,
      };

    case PRODUCT_CONFIG_SUCCESS:
      return {
        ...state,
        productconfigData: data,
        productconfigLoading: false,
      };

    case PRODUCT_CONFIG_ERR:
      return {
        ...state,
        productconfigError: err,
        productconfigLoading: false,
      };

    case OTHER_EXPENSES_BEGIN:
      return {
        ...state,
        otherexpenseLoading: true,
      };

    case OTHER_EXPENSES_SUCCESS:
      return {
        ...state,
        otherexpenseData: data,
        otherexpenseLoading: false,
      };

    case OTHER_EXPENSES_ERR:
      return {
        ...state,
        otherexpenseError: err,
        otherexpenseLoading: false,
      };

    case CASHBACK_BEGIN:
      return {
        ...state,
        cashbackLoading: true,
      };

    case CASHBACK_SUCCESS:
      return {
        ...state,
        cashbackData: data,
        cashbackLoading: false,
      };

    case CASHBACK_ERR:
      return {
        ...state,
        cashbackError: err,
        cashbackLoading: false,
      };

    case EXCEPTION_RULES_BEGIN:
      return {
        ...state,
        exceptionruleLoading: true,
      };

    case EXCEPTION_RULES_SUCCESS:
      return {
        ...state,
        exceptionruleData: data,
        exceptionruleLoading: false,
      };

    case EXCEPTION_RULES_ERR:
      return {
        ...state,
        exceptionruleError: err,
        exceptionruleLoading: false,
      };

    case CONFIG_RECONCILE_BEGIN:
      return {
        ...state,
        configreconcileLoading: true,
      };

    case CONFIG_RECONCILE_SUCCESS:
      return {
        ...state,
        configreconcileData: data,
        configreconcileLoading: false,
      };

    case CONFIG_RECONCILE_ERR:
      return {
        ...state,
        configreconcileError: err,
        configreconcileLoading: false,
      };

    case GET_CHANNELS_BEGIN:
      return {
        ...state,
        getchannelsLoading: true,
      };

    case GET_CHANNELS_SUCCESS:
      return {
        ...state,
        channels: action.data,
        getchannelsLoading: false,
      };

    case GET_CHANNELS_ERR:
      return {
        ...state,
        getchannelsError: err,
        getchannelsLoading: false,
      };

    case USER_INFO_BEGIN:
      return {
        ...state,
        userinfoLoading: true,
      };

    case USER_INFO_SUCCESS:
      return {
        ...state,
        userinfoData: data,
        userinfoLoading: false,
      };

    case USER_INFO_ERR:
      return {
        ...state,
        userinfoError: err,
        userinfoLoading: false,
      };

    case ADD_USER_BEGIN:
      return {
        ...state,
        adduserLoading: true,
        adduserError: null,
      };

    case ADD_USER_SUCCESS:
      return {
        ...state,
        adduserData: data,
        adduserLoading: false,
      };

    case ADD_USER_ERR:
      return {
        ...state,
        adduserError: err,
        adduserLoading: false,
      };

    case GET_SUB_USERS_BEGIN:
      return {
        ...state,
        subUsersLoading: true,
        subUsersError: null,
      };

    case GET_SUB_USERS_SUCCESS:
      return {
        ...state,
        subUsersData: data,
        subUsersLoading: false,
      };

    case GET_SUB_USERS_ERR:
      return {
        ...state,
        subUsersError: err,
        subUsersLoading: false,
      };

    case DELETE_SUB_USER_BEGIN:
      return {
        ...state,
        deleteUserLoading: true,
        deleteUserError: null,
      };

    case DELETE_SUB_USER_SUCCESS:
      return {
        ...state,
        deleteUserLoading: false,
      };

    case DELETE_SUB_USER_ERR:
      return {
        ...state,
        deleteUserError: err,
        deleteUserLoading: false,
      };

    case actions.EXPORT_PRODUCT_CONFIGURATION_BEGIN:
      return {
        ...state,
        exportLoading: true,
      };

    case actions.EXPORT_PRODUCT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        exportLoading: false,
      };

    case actions.EXPORT_PRODUCT_CONFIGURATION_ERR:
      return {
        ...state,
        exportLoading: false,
      };

    case UPLOAD_PRODUCT_CONFIGURATION_BEGIN:
      return {
        ...state,
        uploadLoading: true,
        uploadError: null,
        uploadSuccess: false,
      };

    case UPLOAD_PRODUCT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        uploadLoading: false,
        uploadSuccess: true,
      };

    case UPLOAD_PRODUCT_CONFIGURATION_ERR:
      return {
        ...state,
        uploadLoading: false,
        uploadError: err,
      };

    default:
      return state;
  }
};

export default settingsReducer;
